import { useState, useEffect } from "react";
import axios from "axios";
import { API, useAuth } from "@/App";
import { Package, Loader2, ArrowLeft, Truck, Calendar, CreditCard, Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const STATUS_MAP = {
  confirmed: { label: "Confirmée", cls: "bg-green-100 text-green-700" },
  shipped: { label: "Expédiée", cls: "bg-blue-100 text-blue-700" },
  delivered: { label: "Livrée", cls: "bg-primary/10 text-primary" },
};

const OrdersPage = () => {
  const { token } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get(`${API}/shop/orders`, { headers: { Authorization: `Bearer ${token}` } });
        setOrders(res.data);
      } catch (err) { console.error(err); } finally { setLoading(false); }
    };
    if (token) fetch();
  }, [token]);

  return (
    <div className="min-h-screen pb-24 px-4 pt-4" data-testid="orders-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/shop" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-charcoal mb-4">
          <ArrowLeft className="w-4 h-4" /> Retour à la boutique
        </Link>
        <h1 className="font-heading text-2xl font-bold text-charcoal flex items-center gap-2 mb-5">
          <Package className="w-6 h-6 text-primary" /> Mes commandes
        </h1>

        {loading ? (
          <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-primary" /></div>
        ) : orders.length === 0 ? (
          <Card className="text-center py-12">
            <CardContent>
              <Package className="w-12 h-12 mx-auto text-muted-foreground/20 mb-3" />
              <p className="text-muted-foreground">Aucune commande</p>
              <Link to="/shop"><Button className="mt-4 rounded-full">Découvrir la boutique</Button></Link>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-3">
            {orders.map((order) => (
              <Card key={order.id}>
                <CardContent className="p-4">
                  <div className="flex items-center justify-between mb-2">
                    <p className="font-medium text-charcoal">{order.product_name}</p>
                    <Badge className={STATUS_MAP[order.status]?.cls || ""}>{STATUS_MAP[order.status]?.label || order.status}</Badge>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1">
                      {order.payment_method === "points" ? <Trophy className="w-3 h-3" /> : <CreditCard className="w-3 h-3" />}
                      {order.payment_method === "points" ? "Points" : `${order.amount?.toFixed(2)}€`}
                    </span>
                    <span className="flex items-center gap-1">
                      <Calendar className="w-3 h-3" />
                      Livraison : {new Date(order.estimated_delivery).toLocaleDateString("fr-FR", { day: "numeric", month: "long" })}
                    </span>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersPage;
